var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.news)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.news.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.news.content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }